import React from 'react';

interface AdminEditingBannerProps {
  /** Short label for the content type, e.g. "vehicle" or "event" */
  contentLabel: string;
  /** Display name of the owner (username or organizer name) */
  ownerLabel: string;
  className?: string;
}

/**
 * Visible reminder when a super admin is editing someone else's content.
 */
const AdminEditingBanner: React.FC<AdminEditingBannerProps> = ({
  contentLabel,
  ownerLabel,
  className = '',
}) => (
  <div
    className={`bg-yellow-600/20 border border-yellow-600/50 rounded-lg p-3 ${className}`}
    role="status"
  >
    <div className="flex items-start gap-2">
      <svg
        className="w-5 h-5 text-yellow-400 shrink-0 mt-0.5"
        fill="currentColor"
        viewBox="0 0 20 20"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
          clipRule="evenodd"
        />
      </svg>
      <div>
        <p className="text-yellow-400 font-medium text-sm">
          Super Admin Mode: editing another user&apos;s {contentLabel}
        </p>
        <p className="text-yellow-200/80 text-xs mt-0.5">
          Owner: {ownerLabel}. Changes apply to their {contentLabel}.
        </p>
      </div>
    </div>
  </div>
);

export default AdminEditingBanner;
